import { HttpClient } from '@angular/common/http';
import { ServiceBase } from './base.service';
import { UploadFileDocumento } from '@app/pages/processos/processo/documentos/documentos-form/upload-file';
import { Observable } from 'rxjs/internal/Observable';
import { BlobServiceClient, BlockBlobUploadOptions } from '@azure/storage-blob';
import { map } from 'rxjs/operators';
import { UploadFileSasUrl } from '@app/models/upload-file-sas-url';
import { from } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class AzureStorageService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }

  public realizarUploadAzure(sasData: UploadFileSasUrl, upload: UploadFileDocumento): Observable<number> {
    const idDocumento = this.extrairIdDocumento(sasData.NomeArquivo);

    const blobService = new BlobServiceClient(sasData.SasUrlUpload);
    const containerClient = blobService.getContainerClient('');
    const blobClient = containerClient.getBlockBlobClient(sasData.NomeArquivo);

    upload.progress = 10;

    const optionsBlobClient: BlockBlobUploadOptions = {
      onProgress: (ev) => { 
        upload.progress = Math.round((ev.loadedBytes / upload.File.size) * 80) + 10; 
      },
      blobHTTPHeaders: { blobContentType: upload.File.type }
    };

    return from(blobClient.upload(upload.File, upload.File.size, optionsBlobClient)).pipe(
      map<any, number>(() => idDocumento) 
    );
  }

  private extrairIdDocumento(nomeArquivo: string): number {
    const idString = nomeArquivo.replace(/([A-z]+)\_(\d+)\.([A-z0-9]+)/, "$2");
    return Number.parseInt(idString, 10);
  }

}